import React from 'react';

export const renderDots = (dotsToShow: number, currentPosition: number) => {
    let dots = [];

    for (let i = 0; i < dotsToShow; i++) {
        dots.push(
            <span
                key={'dot_' + i}
                style={currentPosition == i ? { background: '#ccc' } : {}}
            ></span>
        );
    }

    return dots;
};
